import { createTheme, alpha } from "@mui/material";
import { deepmerge } from "@mui/utils";
import baseThemeOptions from "./baseThemeOptions";

const colorSet = {
  primaryMain: "#00204b",
  secondary: "#fb2b55",
  defaultTextColor: "#303030",
};

const themeWbsAcademy = createTheme(
  deepmerge(baseThemeOptions, {
    palette: {
      primary: {
        main: colorSet.primaryMain,
      },

      secondary: {
        main: colorSet.secondary,
      },

      widgetStyles: {
        minimizedChatBubble: {
          backgroundColor: colorSet.primaryMain,
          iconColor: "#fff",
          hoverColor: colorSet.secondary,
        },

        navbar: {
          backgroundColor: colorSet.primaryMain,
          textColor: "#fff",
          chevronColor: "#fff",
          chevronHoverColor: alpha("#0A5EC5", 0.2),
        },

        welcomePage: {
          backgroundColor: "#fff",
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: "#20A9CC",
        },

        dataProtectionPage: {
          backgroundColor: "#fff",
          headlineColor: colorSet.primaryMain,
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: "#20A9CC",
        },

        button: {
          primary: {
            backgroundColor: colorSet.primaryMain,
            textColor: "#fff",
            hoverColor: colorSet.secondary,
          },

          secondary: {
            backgroundColor: "#E0E0E0",
            textColor: colorSet.defaultTextColor,
            hoverColor: "#C7C7C7",
          },
        },

        userChatBubble: {
          background: alpha(colorSet.primaryMain, 0.8),
          textColor: "#fff",
          linkColor: "#fff",
          linkHoverColor: "#20A9CC",
        },

        botChatBubble: {
          background: alpha(colorSet.defaultTextColor, 0.1),
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: "#20A9CC",
        },

        chatControls: {
          backgroundColor: "#fff",
          iconColor: "#637286",
          iconHoverColor: colorSet.secondary,
        },
      },
    },
  })
);

export default themeWbsAcademy;
